<div id="particles-js">
  <!-- <div class="addParticles"></div> -->
</div>

<h1 class="SEO">Work- Rahil Hastu</h1>
<!-- <section style="z-index: 1"> -->
<div class="climbingman">
  <div class="rope">
    <div class="proj-circle-interval">
      <a (click)="sectionChange('intro')" class="interval-0-intro" data-proj="0"
        ><div class="innerCircle"></div
      ></a>
      <a (click)="sectionChange('first')" class="interval-1-proj" data-proj="1"
        ><div></div
      ></a>
      <a (click)="sectionChange('second')" class="interval-2-proj" data-proj="2"
        ><div></div
      ></a>
      <a (click)="sectionChange('third')" class="interval-3-proj" data-proj="3"
        ><div></div
      ></a>
      <a (click)="sectionChange('fourth')" class="interval-4-proj" data-proj="4"
        ><div></div
      ></a>
      <div class="man"></div>
    </div>
  </div>
</div>
<!-- </section> -->

<section id="intro">
  <div class="title-proj intro-title">Scroll to Zipline through my works</div>

  <div class="proj proj-section" id="intro-1">
    <div style="display: none" class="circle activeCircle">
      <p class="proj-desc">
        Intro Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Dignissimos excepturi laboriosam nam adipisci aspernatur, voluptatem
        vel, amet sit nulla iusto ipsam. Vero, molestias, praesentium dolor
        ducimus officiis sunt veniam doloribus eius excepturi nisi explicabo sed
        neque aperiam. Sed, autem quos ea doloremque laborum voluptates fugit
        dolorem blanditiis. Inventore, error temporibus!
      </p>
    </div>
    <div class="proj-image"></div>
  </div>
</section>
<section id="first">
  <div class="title-proj first-title">Diagnostic ECG</div>
  <div data-index="first" class="proj-section proj first" id="first-1">
    <div class="circle">
      <p class="proj-desc">
        I contribute to the team, at GE Healthcare, as a full stack developer
        and work towards the development of different backend features of their
        ECG diagnostic device, MAC VU 360. I am also involved in writing
        automation scripts to test, debug and ensure smooth functioning of the
        device’s various workflows. I also work on improving the existing user
        interface of the device and help tackle various issues and bugs that the
        device might face.<br /><br />
        Techstack: C++, Angular JS, HTML, CSS, Javascript, Python
      </p>
    </div>
  </div>
</section>
<section id="second">
  <div class="title-proj second-title">Real Check</div>
  <div data-index="second" class="proj-section proj second" id="second-1">
    <div class="circle">
      <p class="proj-desc">
        The traditional method of correcting answer sheets in a school/college
        involves teachers correcting answer sheets using an answer key or an
        answer bank.<br />
        RealCheck is a subjective answer evaluation system which uses Natural
        language processing coupled with cosine similarity to find the
        similarity of a student’s answer to correct answers given in the answer
        bank and consequently assign a score to each of a student’s answers.<br />
        Various concepts like stop word removal, tokenization, Parts of
        speech(POS) tagging, Term frequency and document frequency,
        Pydictionary( for synonyms) and cosine similarity are used to achieve
        the same.<br /><br />
        <strong>Techstack: Python, Django, HTML, SQLite3, CSS</strong>
      </p>
    </div>
  </div>
</section>
<section id="third">
  <div class="title-proj third-title">EkkPahel</div>
  <div data-index="third" class="proj-section proj third" id="third-1">
    <div class="circle">
      <p class="proj-desc">
        Contributed to the making of an online portal of the NGO EkkPahel, to
        help conquer the issue of lodging complaints in the district. <br />The
        people of Araria would hesitate to approach the authorities face to face
        regarding complaints or concerns, lest they receive backlash from fellow
        local communities. Our portal allowed such people in the district to
        communicate their complaints and concerns to the local authorities in a
        confidential manner to help bring civil, social issues to light.<br />
        The portal went live on their main website and was also showcased in
        TedX GD Goenka in the year 2018.<br /><br />
        <strong>Techstack: HTML, CSS, Javascript</strong>
      </p>
    </div>
  </div>
</section>
<section id="fourth">
  <div class="title-proj fourth-title">Call A Mail</div>
  <div data-index="fourth" class="proj-section proj fourth" id="fourth-1">
    <div class="circle">
      <p class="proj-desc">
        Missing important mails isn’t a mistake many would appreciate. CallAMail
        can be used to ensure you never miss an important email again. It gives
        you the ability to set up email ids, mails from which are important for
        you. In case a mail arrives from any of these senders and is sitting
        unread in your inbox, you receive a call on your mobile with an
        automated message, urging you to check your emails. It was scheduled
        using cron and installed on the Amazon web server on an ec2 instance.
        <br /><br />
        <strong
          >Techstack: Python, CRON<br /><br />
          Tools Used: AWS, Twilio, Google Cloud Platform</strong
        >
      </p>
    </div>
  </div>
</section>
